/**
 * The id of the actions menu column
 */
const ACTIONS_MENU_COLUMN_ID = '__actions';

/**
 * The id of the action menu target
 */
const ACTION_MENU_TARGET_ID = '__action-target';

export { ACTION_MENU_TARGET_ID, ACTIONS_MENU_COLUMN_ID };
